import { atom } from 'recoil'

export const siteSections = atom({
  key: 'siteSections',
  default: window.laborgg.data.site.language === 'es' ? window.laborgg.data.links.es : window.laborgg.data.links.en,
})

export const siteData = atom({
  key: 'siteData',
  default: window.laborgg.data.site,
})

export const socialData = atom({
  key: 'socialData',
  default: window.laborgg.data.social,
})

export const introData = atom({
  key: 'introData',
  default: window.laborgg.data.intro,
})

export const aboutData = atom({
  key: 'aboutData',
  default: window.laborgg.data.about,
})

export const servicesData = atom({
  key: 'servicesData',
  default: window.laborgg.data.services,
})

export const teamData = atom({
  key: 'teamData',
  default: window.laborgg.data.team,
})

export const clientsData = atom({
  key: 'clientsData',
  default: window.laborgg.data.clients,
})

export const awardsData = atom({
  key: 'awardsData',
  default: window.laborgg.data.awards,
})

export const contactData = atom({
  key: 'contactData',
  default: window.laborgg.data.contact,
})
